module.exports = __webpack_public_path__ + "static/media/miles_cropped.9180f8df.jpg";